import banner from './Advocacia_banner.png';import styled from 'styled-components';

export const BannerContainer = styled.div`
  height: 450px;
  width: 100%;
 
  background-repeat: no-repeat;
  background-size: cover;
  background-color: ${props => props.theme.cores.primaria};
  display: flex;
  align-items: center;
  justify-content: center;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 85%);

  @media (max-width: 768px) {
    width: 100%;
    height: 950px;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: ${props => props.theme.cores.primaria};
  display: flex;
  align-items: center;
  justify-content: center;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 85%);
  }

  
`;
